import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "text-center mb-6" };
const _hoisted_2 = { class: "text-caption text-grey mt-4 text-center" };
const _hoisted_3 = {
    key: 0,
    class: "pa-4 fill-height"
};
const _hoisted_4 = {
    key: 1,
    class: "main-layout pa-4"
};
const _hoisted_5 = { class: "nav-column d-none d-md-flex" };
const _hoisted_6 = { class: "list-column" };
const _hoisted_7 = {
    key: 0,
    class: "d-flex justify-center align-center flex-grow-1"
};
const _hoisted_8 = {
    key: 1,
    class: "pa-4"
};
const _hoisted_9 = { class: "pa-3 border-b" };
const _hoisted_10 = { class: "flex-grow-1 overflow-auto" };
const _hoisted_11 = {
    key: 0,
    class: "pa-3 border-t"
};
const _hoisted_12 = {
    key: 0,
    class: "detail-column"
};
const _hoisted_13 = { class: "pa-4 border-b" };
const _hoisted_14 = {
    key: 0,
    class: "d-flex justify-center"
};
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "pa-4" };
const _hoisted_17 = { class: "pa-4" };
const _hoisted_18 = {
    key: 0,
    class: "d-flex justify-center py-4"
};
const _hoisted_19 = { key: 1 };
const _hoisted_20 = { class: "pa-4" };
const _hoisted_21 = {
    key: 0,
    class: "d-flex justify-center w-100 py-2"
};
const _hoisted_22 = {
    key: 1,
    class: "w-100"
};
const _hoisted_23 = { class: "pa-4 fill-height" };
import { ref, computed, onMounted, watch } from "vue";
import axios from "axios";
import SignIn from "./components/SignIn.vue";
import SummaryInfo from "./components/SummaryInfo.vue";
import TextSearch from "./components/TextSearch.vue";
import DatasetTable from "./components/DatasetTable.vue";
import Manifest from "./components/DatasetManifest.vue";
import Readme from "./components/DatasetReadme.vue";
import DatasetSummary from "./components/DatasetSummary.vue";
import DatasetHeader from "./components/DatasetHeader.vue";
import DatasetSorting from "./components/DatasetSorting.vue";
import UserMenu from "./components/UserMenu.vue";
import NotificationSnackbar from "./components/NotificationSnackbar.vue";
import UserManagement from "./components/UserManagement.vue";
import DatasetDependencies from "./components/DatasetDependencies.vue";
import { useStore } from "./store";
import { useAuthStore } from "./stores/auth";
import { useServerHealthStore } from "./stores/serverHealth";
import { dserverApi } from "./services/dserverApi";
import { parsePaginationHeader } from "dserver-client";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const store = useStore();
        const auth = useAuthStore();
        const serverHealth = useServerHealthStore();
        // App initialization state
        const isInitializing = ref(true);
        // Reactive state
        const drawer = ref(false);
        const datasetHits = ref([]);
        const searchLoading = ref(true);
        const searchErrored = ref(false);
        const searchErrorMessage = ref(null);
        const manifestLoading = ref(false);
        const manifestErrored = ref(false);
        const readmeLoading = ref(false);
        const readmeErrored = ref(false);
        const tagsLoading = ref(false);
        const tagsErrored = ref(false);
        const annotationsLoading = ref(false);
        const annotationsErrored = ref(false);
        const lookup_url = dserverApi.getBaseUrl();
        const getinfo = ref({ versions: {} });
        const detailTab = ref("dataset");
        const currentView = ref("datasets");
        const paginationInfo = ref({
            total: 0,
            page: 1,
            per_page: 10,
            pages: 1,
        });
        // Computed properties
        const datasetLoaded = computed(() => {
            return store.current_dataset;
        });
        const current_dataset = computed(() => {
            return datasetHits.value[store.current_dataset_index];
        });
        // For backward compatibility with mongo search (still uses axios)
        const mongoSearchURL = computed(() => {
            return lookup_url + "/mongo/query";
        });
        const searchQuery = computed(() => {
            const query = {};
            if (store.free_text) {
                query.free_text = store.free_text;
            }
            if (store.creator_usernames.length > 0) {
                query.creator_usernames = store.creator_usernames;
            }
            if (store.base_uris.length > 0) {
                query.base_uris = store.base_uris;
            }
            if (store.tags.length > 0) {
                query.tags = store.tags;
            }
            if (store.uploaded_by.length > 0) {
                query.uploaded_by = store.uploaded_by;
            }
            return query;
        });
        const uriQuery = computed(() => {
            if (datasetHits.value.length > 0) {
                return {
                    uri: datasetHits.value[store.current_dataset_index]?.uri ?? null,
                };
            }
            else {
                return { uri: null };
            }
        });
        const totalPages = computed(() => {
            // Prefer the page count reported by the server.
            if (paginationInfo.value.pages) {
                return paginationInfo.value.pages;
            }
            if (paginationInfo.value.total && paginationInfo.value.per_page) {
                return Math.ceil(paginationInfo.value.total / paginationInfo.value.per_page);
            }
            return 1;
        });
        const shouldShowPagination = computed(() => {
            return paginationInfo.value.total > paginationInfo.value.per_page;
        });
        const safeMongoPlugin = computed(() => {
            return getinfo.value.versions.dserver_direct_mongo_plugin || "N/A";
        });
        const hasDependencyGraphPlugin = computed(() => {
            return !!getinfo.value.versions.dserver_dependency_graph_plugin;
        });
        const itemCount = computed(() => {
            const manifest = store.current_dataset_manifest;
            if (manifest && manifest.items) {
                return Object.keys(manifest.items).length;
            }
            return 0;
        });
        const currentPage = computed({
            get() {
                return store.current_pageNumber;
            },
            set(value) {
                store.current_pageNumber = value;
            },
        });
        // Monotonically increasing id used to discard stale search responses when
        // several searches are in flight (there is no request cancellation).
        let searchSequence = 0;
        // Methods
        function onPageChange() {
            searchDatasets();
        }
        function isAuthenticationError(error) {
            const err = error;
            const status = err.status || err.response?.status;
            return status === 401 || err.name === "AuthenticationError";
        }
        async function searchDatasets() {
            getconfiginfo();
            const sequence = ++searchSequence;
            store.updateCurrentDatasetIndex(0);
            store.updateCurrentDataset(null);
            store.updateCurrentDatasetManifest(null);
            store.updateCurrentDatasetReadme(null);
            store.updateCurrentDatasetTags(null);
            store.updateCurrentDatasetAnnotations(null);
            searchLoading.value = true;
            searchErrored.value = false;
            // Handle mongo query separately (legacy)
            if (store.mongo_text) {
                try {
                    const response = await axios.post(mongoSearchURL.value, { query: JSON.parse(store.mongo_text) }, {
                        params: {
                            page: store.current_pageNumber,
                            page_size: store.update_current_Per_Page,
                        },
                        headers: {
                            Authorization: `Bearer ${auth.token || ""}`,
                            "Content-Type": "application/json",
                        },
                    });
                    if (sequence !== searchSequence)
                        return;
                    datasetHits.value = response.data;
                    // The X-Pagination header is in flask-smorest format (total_pages,
                    // no per_page); normalize it the same way dserver-client does.
                    paginationInfo.value = parsePaginationHeader(response.headers["x-pagination"], store.update_current_Per_Page, response.data.length);
                    store.updateCurrentDataset(current_dataset.value ?? null);
                    store.updateNumFiltered(paginationInfo.value.total);
                    updateDataset();
                }
                catch (error) {
                    if (sequence !== searchSequence)
                        return;
                    handleSearchError(error);
                }
                finally {
                    if (sequence === searchSequence) {
                        searchLoading.value = false;
                    }
                }
                return;
            }
            // Use dserverApi for standard search
            try {
                const result = await dserverApi.searchDatasets(searchQuery.value, {
                    page: store.current_pageNumber,
                    page_size: store.update_current_Per_Page,
                    sort: store.selected_sort_option,
                });
                if (sequence !== searchSequence)
                    return;
                datasetHits.value = result.data;
                paginationInfo.value = result.pagination;
                store.updateCurrentDataset(current_dataset.value ?? null);
                store.updateNumFiltered(result.pagination.total);
                updateDataset();
            }
            catch (error) {
                if (sequence !== searchSequence)
                    return;
                handleSearchError(error);
            }
            finally {
                if (sequence === searchSequence) {
                    searchLoading.value = false;
                }
            }
        }
        function handleSearchError(error) {
            const err = error;
            const status = err.status || err.response?.status;
            if (isAuthenticationError(error)) {
                // Auth store will handle this - logout the user
                auth.logout();
            }
            else if (status === 404 && store.current_pageNumber > 1) {
                // Out-of-range page (e.g. after changing the page size): retry once
                // from the first page. Only when not already there, to avoid a loop.
                store.current_pageNumber = 1;
                searchDatasets();
            }
            else {
                searchErrorMessage.value = "An error occurred while loading datasets.";
                searchErrored.value = true;
            }
        }
        function updateDataset() {
            updateManifest();
            updateReadme();
            updateAnnotations();
            updateTags();
        }
        async function handleDependencyNavigation(uuid) {
            // Navigate to a dataset from the dependency graph
            // Keep the Dependencies tab open so user can continue exploring the graph
            const sequence = ++searchSequence;
            try {
                // Search using free text with the UUID to find the dataset
                const result = await dserverApi.searchDatasets({ free_text: uuid });
                if (sequence !== searchSequence)
                    return;
                if (result.data.length > 0) {
                    // Find the exact match by UUID
                    const exactMatch = result.data.find((d) => d.uuid === uuid);
                    const dataset = exactMatch || result.data[0];
                    datasetHits.value = result.data;
                    paginationInfo.value = result.pagination;
                    const datasetIndex = result.data.findIndex((d) => d.uuid === uuid);
                    store.updateCurrentDatasetIndex(datasetIndex >= 0 ? datasetIndex : 0);
                    store.updateCurrentDataset(dataset);
                    store.updateNumFiltered(result.pagination.total);
                    updateDataset();
                    // Keep the dependencies tab open (don't switch tabs)
                }
            }
            catch (error) {
                console.error("Failed to navigate to dataset:", error);
            }
        }
        /**
         * True while the response for `uri` is still the one the UI is waiting for.
         * Late responses for a previously selected dataset are discarded.
         */
        function isCurrentUri(uri) {
            return store.current_dataset?.uri === uri || uriQuery.value.uri === uri;
        }
        async function updateManifest() {
            manifestLoading.value = true;
            manifestErrored.value = false;
            const uri = uriQuery.value.uri;
            if (!uri) {
                manifestErrored.value = true;
                manifestLoading.value = false;
                return;
            }
            try {
                const manifest = await dserverApi.getManifest(uri);
                if (!isCurrentUri(uri))
                    return;
                store.updateCurrentDatasetManifest(manifest);
            }
            catch (error) {
                if (!isCurrentUri(uri))
                    return;
                if (isAuthenticationError(error)) {
                    auth.logout();
                    return;
                }
                manifestErrored.value = true;
            }
            finally {
                if (isCurrentUri(uri)) {
                    manifestLoading.value = false;
                }
            }
        }
        async function updateReadme() {
            readmeLoading.value = true;
            readmeErrored.value = false;
            const uri = uriQuery.value.uri;
            if (!uri) {
                readmeErrored.value = true;
                readmeLoading.value = false;
                return;
            }
            try {
                const readme = await dserverApi.getReadme(uri);
                if (!isCurrentUri(uri))
                    return;
                store.updateCurrentDatasetReadme(readme);
            }
            catch (error) {
                if (!isCurrentUri(uri))
                    return;
                if (isAuthenticationError(error)) {
                    auth.logout();
                    return;
                }
                readmeErrored.value = true;
            }
            finally {
                if (isCurrentUri(uri)) {
                    readmeLoading.value = false;
                }
            }
        }
        async function updateAnnotations() {
            annotationsLoading.value = true;
            annotationsErrored.value = false;
            const uri = uriQuery.value.uri;
            if (!uri) {
                annotationsErrored.value = true;
                annotationsLoading.value = false;
                return;
            }
            try {
                const annotations = await dserverApi.getAnnotations(uri);
                if (!isCurrentUri(uri))
                    return;
                store.updateCurrentDatasetAnnotations(annotations);
            }
            catch (error) {
                if (!isCurrentUri(uri))
                    return;
                if (isAuthenticationError(error)) {
                    auth.logout();
                    return;
                }
                annotationsErrored.value = true;
            }
            finally {
                if (isCurrentUri(uri)) {
                    annotationsLoading.value = false;
                }
            }
        }
        async function updateTags() {
            tagsLoading.value = true;
            tagsErrored.value = false;
            const uri = uriQuery.value.uri;
            if (!uri) {
                tagsErrored.value = true;
                tagsLoading.value = false;
                return;
            }
            try {
                const tags = await dserverApi.getTags(uri);
                if (!isCurrentUri(uri))
                    return;
                store.updateCurrentDatasetTags(tags);
            }
            catch (error) {
                if (!isCurrentUri(uri))
                    return;
                if (isAuthenticationError(error)) {
                    auth.logout();
                    return;
                }
                tagsErrored.value = true;
            }
            finally {
                if (isCurrentUri(uri)) {
                    tagsLoading.value = false;
                }
            }
        }
        async function getconfiginfo() {
            // Store the lookup URL in the store for components to use
            store.updateLookupUrl(lookup_url);
            try {
                const versions = await dserverApi.getServerVersions();
                getinfo.value = { versions };
                store.updateServerVersions(versions);
            }
            catch (error) {
                console.error("Failed to load server versions:", error);
            }
        }
        function handleLogout() {
            auth.logout();
            searchErrorMessage.value = null;
            searchErrored.value = false;
            store.clearAll();
        }
        async function retryServerConnection() {
            const healthy = await serverHealth.checkHealth();
            if (healthy) {
                // Re-initialize auth only if the session was not restored already;
                // re-running login on an intact session is unnecessary.
                if (!auth.isAuthenticated) {
                    await auth.initialize();
                }
                isInitializing.value = false;
            }
        }
        // Watch for authentication state changes
        watch(() => auth.isAuthenticated, (isAuthenticated) => {
            if (isAuthenticated) {
                // User just logged in, start search
                searchDatasets();
            }
        });
        // Initialize the app
        onMounted(async () => {
            // First check server health
            const serverHealthy = await serverHealth.initialize();
            if (!serverHealthy) {
                isInitializing.value = false;
                return;
            }
            // Then initialize auth (will check for existing token or OAuth2 callback).
            // The isAuthenticated watcher above triggers the initial search.
            await auth.initialize();
            isInitializing.value = false;
        });
        return (_ctx, _cache) => {
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_main = _resolveComponent("v-main");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon");
            const _component_v_img = _resolveComponent("v-img");
            const _component_v_avatar = _resolveComponent("v-avatar");
            const _component_v_app_bar_title = _resolveComponent("v-app-bar-title");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_app_bar = _resolveComponent("v-app-bar");
            const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer");
            const _component_v_pagination = _resolveComponent("v-pagination");
            const _component_v_tab = _resolveComponent("v-tab");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_tabs = _resolveComponent("v-tabs");
            const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item");
            const _component_v_tabs_window = _resolveComponent("v-tabs-window");
            const _component_v_app = _resolveComponent("v-app");
            return (_openBlock(), _createBlock(_component_v_app, null, {
                default: _withCtx(() => [
                    (isInitializing.value)
                        ? (_openBlock(), _createBlock(_component_v_main, {
                            key: 0,
                            class: "d-flex align-center justify-center bg-grey-lighten-4"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                    class: "pa-8 text-center",
                                    "max-width": "400"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_progress_circular, {
                                            indeterminate: "",
                                            color: "primary",
                                            size: "64",
                                            class: "mb-4"
                                        }),
                                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-body-1 text-grey-darken-1" }, "Connecting to server...", -1))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : (_unref(serverHealth).isUnhealthy)
                            ? (_openBlock(), _createBlock(_component_v_main, {
                                key: 1,
                                class: "d-flex align-center justify-center bg-grey-lighten-4"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                        class: "pa-8",
                                        "max-width": "500"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_1, [
                                                _createVNode(_component_v_icon, {
                                                    icon: "mdi-server-off",
                                                    size: "80",
                                                    color: "error"
                                                })
                                            ]),
                                            _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "text-h5 font-weight-bold text-center mb-4 text-error" }, " Server Unavailable ", -1)),
                                            _createVNode(_component_v_alert, {
                                                type: "error",
                                                variant: "tonal",
                                                class: "mb-4"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(serverHealth).errorMessage || "Unable to connect to the dserver."), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1 mb-4" }, " The dtool lookup server is not responding. This could be due to: ", -1)),
                                            _cache[18] || (_cache[18] = _createElementVNode("ul", { class: "text-body-2 text-grey-darken-1 mb-6 ml-4" }, [
                                                _createElementVNode("li", null, "Server maintenance or downtime"),
                                                _createElementVNode("li", null, "Network connectivity issues"),
                                                _createElementVNode("li", null, "Server configuration problems")
                                            ], -1)),
                                            _createVNode(_component_v_btn, {
                                                color: "primary",
                                                block: "",
                                                loading: _unref(serverHealth).isChecking,
                                                onClick: retryServerConnection
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, {
                                                        icon: "mdi-refresh",
                                                        class: "mr-2"
                                                    }),
                                                    _cache[15] || (_cache[15] = _createTextVNode(" Retry Connection ", -1))
                                                ]),
                                                _: 1
                                            }, 8, ["loading"]),
                                            _createElementVNode("p", _hoisted_2, " Server URL: " + _toDisplayString(_unref(serverHealth).serverUrl), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : (!_unref(auth).isAuthenticated)
                                ? (_openBlock(), _createBlock(_component_v_main, { key: 2 }, {
                                    default: _withCtx(() => [
                                        _createVNode(SignIn)
                                    ]),
                                    _: 1
                                }))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createVNode(_component_v_app_bar, {
                                        color: "grey-lighten-3",
                                        elevation: "2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_app_bar_nav_icon, {
                                                class: "d-md-none",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (drawer.value = !drawer.value))
                                            }),
                                            _createVNode(_component_v_avatar, {
                                                size: "36",
                                                class: "ml-2 mr-2"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_img, {
                                                        src: "/icons/128x128/dtool_logo.png",
                                                        alt: "dtool Logo"
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_app_bar_title, { class: "text-primary font-weight-bold flex-grow-0" }, {
                                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                        _createTextVNode(" dtool ", -1)
                                                    ]))]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_spacer),
                                            (currentView.value === 'datasets')
                                                ? (_openBlock(), _createBlock(TextSearch, {
                                                    key: 0,
                                                    mongoplugin: safeMongoPlugin.value,
                                                    onStartSearch: searchDatasets
                                                }, null, 8, ["mongoplugin"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_v_spacer),
                                            (_unref(auth).isAdmin)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 1,
                                                    variant: currentView.value === 'users' ? 'tonal' : 'text',
                                                    color: currentView.value === 'users' ? 'primary' : undefined,
                                                    class: "mr-2",
                                                    onClick: _cache[1] || (_cache[1] = ($event) => (currentView.value = currentView.value === 'users' ? 'datasets' : 'users'))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { class: "mr-1" }, {
                                                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                                    _createTextVNode("mdi-account-cog", -1)
                                                                ]))]),
                                                            _: 1
                                                        }),
                                                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "d-none d-sm-inline" }, "Users", -1))
                                                    ]),
                                                    _: 1
                                                }, 8, ["variant", "color"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(UserMenu, { onLogoutAction: handleLogout })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_navigation_drawer, {
                                        modelValue: drawer.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((drawer).value = $event)),
                                        temporary: "",
                                        class: "d-md-none"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(SummaryInfo, { onStartSearch: searchDatasets })
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_v_main, { class: "bg-grey-lighten-4" }, {
                                        default: _withCtx(() => [
                                            (currentView.value === 'users' && _unref(auth).isAdmin)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                    _createVNode(UserManagement)
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                    _createElementVNode("div", _hoisted_5, [
                                                        _createVNode(_component_v_card, {
                                                            class: "fill-height overflow-auto",
                                                            variant: "flat",
                                                            rounded: "lg"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(SummaryInfo, { onStartSearch: searchDatasets })
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_6, [
                                                        _createVNode(_component_v_card, {
                                                            class: "fill-height d-flex flex-column",
                                                            variant: "elevated",
                                                            rounded: "lg"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (searchLoading.value)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                                        _createVNode(_component_v_progress_circular, {
                                                                            indeterminate: "",
                                                                            color: "primary",
                                                                            size: "48"
                                                                        })
                                                                    ]))
                                                                    : (searchErrored.value)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                                            _createVNode(_component_v_alert, {
                                                                                type: "error",
                                                                                class: "mb-4"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(searchErrorMessage.value ||
                                                                                        "Unable to load datasets please try again."), 1)
                                                                                ]),
                                                                                _: 1
                                                                            }),
                                                                            _createVNode(_component_v_btn, {
                                                                                color: "secondary",
                                                                                class: "mr-2",
                                                                                onClick: _cache[3] || (_cache[3] = ($event) => (searchDatasets()))
                                                                            }, {
                                                                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                                                        _createTextVNode(" Try again ", -1)
                                                                                    ]))]),
                                                                                _: 1
                                                                            }),
                                                                            _createVNode(_component_v_btn, {
                                                                                color: "secondary",
                                                                                onClick: _cache[4] || (_cache[4] = ($event) => (handleLogout()))
                                                                            }, {
                                                                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                                                        _createTextVNode(" Logout ", -1)
                                                                                    ]))]),
                                                                                _: 1
                                                                            })
                                                                        ]))
                                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                            _createElementVNode("div", _hoisted_9, [
                                                                                _createVNode(DatasetSorting, { onStartSearch: searchDatasets })
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_10, [
                                                                                _createVNode(DatasetTable, {
                                                                                    datasetHits: datasetHits.value,
                                                                                    onUpdateDataset: updateDataset
                                                                                }, null, 8, ["datasetHits"])
                                                                            ]),
                                                                            (shouldShowPagination.value)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                                                    _createVNode(_component_v_pagination, {
                                                                                        modelValue: currentPage.value,
                                                                                        "onUpdate:modelValue": [
                                                                                            _cache[5] || (_cache[5] = ($event) => ((currentPage).value = $event)),
                                                                                            onPageChange
                                                                                        ],
                                                                                        length: totalPages.value,
                                                                                        "total-visible": 5,
                                                                                        density: "compact",
                                                                                        rounded: ""
                                                                                    }, null, 8, ["modelValue", "length"])
                                                                                ]))
                                                                                : _createCommentVNode("", true)
                                                                        ], 64))
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    (datasetLoaded.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                            _createVNode(_component_v_card, {
                                                                class: "fill-height d-flex flex-column",
                                                                variant: "elevated",
                                                                rounded: "lg"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_13, [
                                                                        (manifestLoading.value)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                                                _createVNode(_component_v_progress_circular, {
                                                                                    indeterminate: "",
                                                                                    color: "primary",
                                                                                    size: "24"
                                                                                })
                                                                            ]))
                                                                            : (manifestErrored.value)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                                                    _createVNode(_component_v_alert, {
                                                                                        type: "error",
                                                                                        density: "compact",
                                                                                        class: "mb-2"
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                                                                _createTextVNode(" Unable to load manifest please try again. ", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    }),
                                                                                    _createVNode(_component_v_btn, {
                                                                                        size: "small",
                                                                                        color: "secondary",
                                                                                        class: "mr-2",
                                                                                        onClick: _cache[6] || (_cache[6] = ($event) => (updateManifest()))
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                                                                _createTextVNode(" Try again ", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    }),
                                                                                    _createVNode(_component_v_btn, {
                                                                                        size: "small",
                                                                                        color: "secondary",
                                                                                        onClick: _cache[7] || (_cache[7] = ($event) => (handleLogout()))
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                                                                _createTextVNode(" Logout ", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    })
                                                                                ]))
                                                                                : (_openBlock(), _createBlock(DatasetHeader, { key: 2 }))
                                                                    ]),
                                                                    _createVNode(_component_v_tabs, {
                                                                        modelValue: detailTab.value,
                                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((detailTab).value = $event)),
                                                                        color: "primary",
                                                                        class: "border-b"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_tab, { value: "dataset" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createVNode(_component_v_icon, {
                                                                                        size: "small",
                                                                                        class: "mr-2"
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                                                                _createTextVNode("mdi-database", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    }),
                                                                                    _cache[28] || (_cache[28] = _createTextVNode(" Dataset ", -1))
                                                                                ]),
                                                                                _: 1
                                                                            }),
                                                                            _createVNode(_component_v_tab, { value: "readme" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createVNode(_component_v_icon, {
                                                                                        size: "small",
                                                                                        class: "mr-2"
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                                                                _createTextVNode("mdi-file-document-outline", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    }),
                                                                                    _cache[30] || (_cache[30] = _createTextVNode(" README ", -1))
                                                                                ]),
                                                                                _: 1
                                                                            }),
                                                                            _createVNode(_component_v_tab, { value: "items" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createVNode(_component_v_icon, {
                                                                                        size: "small",
                                                                                        class: "mr-2"
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                                                                                _createTextVNode("mdi-file-tree", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    }),
                                                                                    _cache[32] || (_cache[32] = _createTextVNode(" Items ", -1)),
                                                                                    (itemCount.value > 0)
                                                                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                                            key: 0,
                                                                                            size: "x-small",
                                                                                            variant: "tonal",
                                                                                            color: "primary",
                                                                                            class: "ml-2"
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                _createTextVNode(_toDisplayString(itemCount.value), 1)
                                                                                            ]),
                                                                                            _: 1
                                                                                        }))
                                                                                        : _createCommentVNode("", true)
                                                                                ]),
                                                                                _: 1
                                                                            }),
                                                                            (hasDependencyGraphPlugin.value)
                                                                                ? (_openBlock(), _createBlock(_component_v_tab, {
                                                                                    key: 0,
                                                                                    value: "dependencies"
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createVNode(_component_v_icon, {
                                                                                            size: "small",
                                                                                            class: "mr-2"
                                                                                        }, {
                                                                                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                                                                                    _createTextVNode("mdi-graph-outline", -1)
                                                                                                ]))]),
                                                                                            _: 1
                                                                                        }),
                                                                                        _cache[34] || (_cache[34] = _createTextVNode(" Dependencies ", -1))
                                                                                    ]),
                                                                                    _: 1
                                                                                }))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["modelValue"]),
                                                                    _createVNode(_component_v_tabs_window, {
                                                                        modelValue: detailTab.value,
                                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((detailTab).value = $event)),
                                                                        class: "flex-grow-1 overflow-auto"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_tabs_window_item, {
                                                                                value: "dataset",
                                                                                class: "fill-height"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createElementVNode("div", _hoisted_16, [
                                                                                        _createVNode(DatasetSummary)
                                                                                    ])
                                                                                ]),
                                                                                _: 1
                                                                            }),
                                                                            _createVNode(_component_v_tabs_window_item, {
                                                                                value: "readme",
                                                                                class: "fill-height"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createElementVNode("div", _hoisted_17, [
                                                                                        (readmeLoading.value)
                                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                                                                _createVNode(_component_v_progress_circular, {
                                                                                                    indeterminate: "",
                                                                                                    color: "primary",
                                                                                                    size: "24"
                                                                                                })
                                                                                            ]))
                                                                                            : (readmeErrored.value)
                                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                                                                    _createVNode(_component_v_alert, {
                                                                                                        type: "error",
                                                                                                        density: "compact",
                                                                                                        class: "mb-2"
                                                                                                    }, {
                                                                                                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                                                                                                _createTextVNode(" Unable to load readme please try again. ", -1)
                                                                                                            ]))]),
                                                                                                        _: 1
                                                                                                    }),
                                                                                                    _createVNode(_component_v_btn, {
                                                                                                        size: "small",
                                                                                                        color: "secondary",
                                                                                                        class: "mr-2",
                                                                                                        onClick: _cache[9] || (_cache[9] = ($event) => (updateReadme()))
                                                                                                    }, {
                                                                                                        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                                                                                                _createTextVNode(" Try again ", -1)
                                                                                                            ]))]),
                                                                                                        _: 1
                                                                                                    }),
                                                                                                    _createVNode(_component_v_btn, {
                                                                                                        size: "small",
                                                                                                        color: "secondary",
                                                                                                        onClick: _cache[10] || (_cache[10] = ($event) => (handleLogout()))
                                                                                                    }, {
                                                                                                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                                                                                                _createTextVNode(" Logout ", -1)
                                                                                                            ]))]),
                                                                                                        _: 1
                                                                                                    })
                                                                                                ]))
                                                                                                : (_openBlock(), _createBlock(Readme, {
                                                                                                    key: 2,
                                                                                                    getinfo: getinfo.value
                                                                                                }, null, 8, ["getinfo"]))
                                                                                    ])
                                                                                ]),
                                                                                _: 1
                                                                            }),
                                                                            _createVNode(_component_v_tabs_window_item, {
                                                                                value: "items",
                                                                                class: "fill-height"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createElementVNode("div", _hoisted_20, [
                                                                                        (manifestLoading.value)
                                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                                                                _createVNode(_component_v_progress_circular, {
                                                                                                    indeterminate: "",
                                                                                                    color: "primary",
                                                                                                    size: "24"
                                                                                                })
                                                                                            ]))
                                                                                            : (manifestErrored.value)
                                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                                                                    _createVNode(_component_v_alert, {
                                                                                                        type: "error",
                                                                                                        density: "compact",
                                                                                                        class: "mb-2"
                                                                                                    }, {
                                                                                                        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                                                                                                _createTextVNode(" Unable to load manifest please try again. ", -1)
                                                                                                            ]))]),
                                                                                                        _: 1
                                                                                                    }),
                                                                                                    _createVNode(_component_v_btn, {
                                                                                                        size: "small",
                                                                                                        color: "secondary",
                                                                                                        class: "mr-2",
                                                                                                        onClick: _cache[11] || (_cache[11] = ($event) => (updateManifest()))
                                                                                                    }, {
                                                                                                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                                                                                                _createTextVNode(" Try again ", -1)
                                                                                                            ]))]),
                                                                                                        _: 1
                                                                                                    }),
                                                                                                    _createVNode(_component_v_btn, {
                                                                                                        size: "small",
                                                                                                        color: "secondary",
                                                                                                        onClick: _cache[12] || (_cache[12] = ($event) => (handleLogout()))
                                                                                                    }, {
                                                                                                        default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                                                                                _createTextVNode(" Logout ", -1)
                                                                                                            ]))]),
                                                                                                        _: 1
                                                                                                    })
                                                                                                ]))
                                                                                                : (_openBlock(), _createBlock(Manifest, {
                                                                                                    key: 2,
                                                                                                    class: "w-100"
                                                                                                }))
                                                                                    ])
                                                                                ]),
                                                                                _: 1
                                                                            }),
                                                                            (hasDependencyGraphPlugin.value)
                                                                                ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                                                                                    key: 0,
                                                                                    value: "dependencies",
                                                                                    class: "fill-height"
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createElementVNode("div", _hoisted_23, [
                                                                                            _createVNode(DatasetDependencies, { onSelectDataset: handleDependencyNavigation })
                                                                                        ])
                                                                                    ]),
                                                                                    _: 1
                                                                                }))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["modelValue"])
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                        ]),
                                        _: 1
                                    })
                                ], 64)),
                    _createVNode(NotificationSnackbar)
                ]),
                _: 1
            }));
        };
    }
});
